import { ProductTileOverlayProps } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductTileOverlay/productTileOverlayProps";
import { ILeanProductTile } from "@faire/web-api--source/indigofair/data/ILeanProductTile";

export const productTileOverlayProductTileAdaptor = (
  productTile: ILeanProductTile,
  includeContainer?: boolean
): ProductTileOverlayProps => {
  return {
    state: productTile.product?.state,
    includeContainer: includeContainer,
  };
};
